import React from "react";
import { Tabs } from "antd";
import CardDetails from "./cardDetails";
import AdminCardContract from "./cardContract";
function CardControl({ id, onDataUpdate, onCloseDrawer }) {
  const items = [
    {
      label: "جزییات کارت",
      key: "1",
      children: (
        <CardDetails
          id={id}
          onDataUpdate={onDataUpdate}
          onCloseDrawer={onCloseDrawer}
        />
      ),
    },
    { label: "تعهدنامه", key: "2", children: <AdminCardContract id={id}/> },
  ];
  return (
    <div>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
}

export default CardControl;
